/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Table_ActionInputs */

const en_team_manager_table_action = /** @type {(inputs: Team_Manager_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const fr_team_manager_table_action = /** @type {(inputs: Team_Manager_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const de_team_manager_table_action = /** @type {(inputs: Team_Manager_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion`)
};

const it_team_manager_table_action = /** @type {(inputs: Team_Manager_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azione`)
};

const ru_team_manager_table_action = /** @type {(inputs: Team_Manager_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действие`)
};

const es_team_manager_table_action = /** @type {(inputs: Team_Manager_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción`)
};

const zh_cn2_team_manager_table_action = /** @type {(inputs: Team_Manager_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行动`)
};

const ja_team_manager_table_action = /** @type {(inputs: Team_Manager_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクション`)
};

const hi_team_manager_table_action = /** @type {(inputs: Team_Manager_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्रवाई`)
};

const pt_pt2_team_manager_table_action = /** @type {(inputs: Team_Manager_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ação`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Team_Manager_Table_ActionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_table_action = /** @type {((inputs?: Team_Manager_Table_ActionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Table_ActionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_table_action(inputs)
	if (locale === "de") return de_team_manager_table_action(inputs)
	if (locale === "it") return it_team_manager_table_action(inputs)
	if (locale === "ru") return ru_team_manager_table_action(inputs)
	if (locale === "es") return es_team_manager_table_action(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_table_action(inputs)
	if (locale === "ja") return ja_team_manager_table_action(inputs)
	if (locale === "hi") return hi_team_manager_table_action(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_table_action(inputs)
	return en_team_manager_table_action(inputs)
});